import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LayoutContext } from '../../../../layout-context.model';
import { AppRoutes, NavLinks } from '@app/core/routing';
import { UiModule } from '@app/ui';

@Component({
  selector: 'gb-footer-branded',
  standalone: true,
  imports: [CommonModule, RouterModule, UiModule],
  templateUrl: './footer-branded.component.html',
})
export class FooterBrandedComponent {
  protected readonly AppRoutes = AppRoutes;
  protected readonly NavLinks = NavLinks;

  @Input({ required: true }) ctx!: LayoutContext;

  readonly year = new Date().getFullYear();
}
